<template>
<div class="page page_live">
    <div class="tradesmanInfo" v-if="livingDetail != null">
        <div class="attention_status_btn" @click="attention">{{ livingDetail.attention_status == null ? '关注' : '已关注' }}</div>
        <img class="thumb" :src="
                    livingDetail != null && livingDetail.info.tradesman  && livingDetail.info.tradesman.thumb
                        ? ($publicData.withHttpStart(livingDetail.info.tradesman.thumb) ? livingDetail.info.tradesman.thumb : imageUrl+livingDetail.info.tradesman.thumb)
                        : $publicData.defaultTouxiang
                " />
        <div class="tInfos">
            <p class="tradesmanName">{{ livingDetail.info.tradesman.nickname }}</p>
            <p class="livingNum">{{ livingDetail.count }}人在线</p>
        </div>
    </div>
    <div class="prism-player" :id="playerId" :style="playStyle"></div>
    <div class="living_tabs">
        <div class="tab_content fullS msgList" id="msgList1" @touchstart="msgTouchStart" @touchend="msgTouchEnd" @touchmove="msgTouchMove" @scroll="msgScroll">
            <div class="interaction_content">
                <div class="i_item" v-for="(item, key) in socketMsg" :key="key">
                    <div class="i_msg">{{ item }}</div>
                </div>
            </div>
        </div>
        <van-tabs class="living_vantab" v-model="tabActive" line-width=".7rem">
            <van-tab title="互动" name="interaction">
                <div class="tab_content msgList" id="msgList2" @touchstart="msgTouchStart" @touchend="msgTouchEnd" @touchmove="msgTouchMove" @scroll="msgScroll">
                    <div class="interaction_content">
                        <div class="i_item" v-for="(item, key) in socketMsg" :key="key">
                            <div class="i_msg">{{ item }}</div>
                        </div>
                    </div>
                </div>
            </van-tab>
            <van-tab title="直播介绍" name="describe">
                <div class="tab_content">
                    <div class="living_describe" v-if="livingDetail != null" v-html="livingDetail.info.describe"></div>
                </div>
            </van-tab>
        </van-tabs>
        <div class="socket_fix_bottom">
            <div class="fix_bottom_send_msg">
                <button type="button" class="send_btn" @click="sendMsg">发送</button>
                <input type="text" placeholder="互动留言~" v-model="msg" class="send_ipt" @keypress="checkMsg" @blur="resetWindow" confirm-type='send' />
            </div>
			<!-- 分享 -->
			<div class="fix_bottom_poster" @click="show_poster = true">
				<img :src="publicPath + 'statics/images/icon_share_poster.png'" class="share_icon" alt="">
			</div>
        </div>
    </div>
	<!-- 分享的图片,类似海报 -->
	<van-overlay :show="show_poster" @click="show_poster = false" class="" z-index="10000"/>
	<div class="poster" v-if="show_poster">
		<img :src="imageUrl + posterUrl" alt="" class="posterTu">
	</div>
	<div class="share_tips" v-if="show_poster">长按保存图片</div>
</div>
</template>

<script>
import router from '../../../.././router';
import {
    LOGOUT,
    LOGIN
} from '../../../.././vuex/mutation_types';
import PageSearch from '../../../component/search/Index.vue';
import Vue from 'vue';
import Bridge from '../../../.././vuex/bridge.js';
Vue.prototype.$bridge = Bridge;
var userAgent = navigator.userAgent;

export default {
    data() {
        return {
			imageUrl: this.$publicData.uploadImage,
            isClient: false,
            token: null,
            playerId: 'aliplayer_' +
                Math.random()
                .toString(36)
                .substr(2),
            scriptTagStatus: 0,
            isReload: false,
            instance: null,
            livingDetail: null,
            playStyle: {
                height: '40vh'
            },
            tabActive: 'interaction',
            websock: null, // websocket
            socketMsg: [], // socket 接收的数据
            username: this.$store.getters.user_name,
            msg: '', // 发送的信息；
            isTouch: false, // 手指是否按在列表上
            startTouch: 0, // 互动列表按下时的y坐标
			goBottom: true, // 接收新消息时是否自动滚动到底部（当列表滚动条距离底部大于40时或 为false ,小于等于40true）
			publicPath: process.env.BASE_URL,
			show_poster: false, // 海报弹层
			posterUrl: null // 分享图链接
        };
    },
    created() {
		
    },
    watch: {
        'window.scroll': function (n, o) {
            console.log(n);
        }
    },
    mounted() {
        var that = this
        if (userAgent && userAgent.indexOf('shidaijiyi') != -1) {
            this.isClient = true
            var params = {
                data: {
                    // naviBlackStyle: true,
                    naviTitle: "直播详情",
                    'rightStyle': 'share'
                    // levitate: true
                },
            };
            this.$bridge.callhandler('sdjy://navigation/style', params, data => {});
            //获取用户信息
            var memberParams = {
                data: {
                    'notCallLogin': 1,
                    // 'forceLogin': 1,
                }
            };
            this.$bridge.callhandler('sdjy://member/memberInfo', memberParams, data => {
                if (data.code == 200) {
                    this.token = data.result.token;
                } else {
                    this.token = '';
                }
                this.getLivingDetail();
            });
            //注册方法，客户端重新进入页面刷新数据
            this.$bridge.registerhandler('sdjy://common/refreshPage', (data, responseCallback) => {
                // alert(JSON.stringify(data));
                responseCallback(data);
            });
            //注册方法，右侧点击分享
            this.$bridge.registerhandler('sdjy://common/rightButtonAction', (data, responseCallback) => {
                // alert(JSON.stringify(data));
                console.log('sdjy://common/rightButtonAction')
                const url = location.href.split('#')[0];
                var params = {
                    data: {
                        title: that.livingDetail.info.title ? that.livingDetail.info.title : that.$publicData.shareDefaultTitleA,
                        detail: that.livingDetail.info.describe ? that.livingDetail.info.describe : '',
                        url: url,
                        platFormType:'',
                        image: that.livingDetail.info.thumb ? that.$publicData.domain + that.livingDetail.info.thumb : that.$publicData.domain + that.$publicData.shareDefaultIcon
                    },
                };
                this.$bridge.callhandler('sdjy://public/share', params, (data) => {

                })

            })
        } else {
            this.isClient = false
            this.token = this.$store.getters.token;
            this.getLivingDetail();
            let that = this;
            document.body.addEventListener(
                'touchmove',
                function (ev) {
                    if (that.$route.name == 'zhibo-detail') {
                        ev.preventDefault();
                    }
                }, {
                    passive: false
                }
            );
            // $("body").on('touchmove',function(ev) {
            //     ev.preventDefault();
            // })
            // this.getShareData()
		}
		if(this.websock){
			this.websock.close(); // 关闭websocket连接
		}
		// else{
		// 	this.initWebSocket();
		// }
    },
    destroyed() {
        console.log('this.websock:',this.websock )
        if ( this.websock != null ) {
            this.userComeIn()
            this.websock.close(); //离开路由之后断开websocket连接
        }

        // document.body.removeEventListener('touchmove', this.pdefault());

        // $("body").off('touchmove',function(ev) {
        //     ev.preventDefault();
        // })
    },
    methods: {
        // pdefault(ev) {
        //     ev.preventDefault();
        // },
        getLivingNoUserDetail() {
            this.$api.living.livingNoUserDetail({
                id: this.$route.query.id
            }).then(res => {
                console.log(res);
                if (res.code == 200) {
					this.livingDetail = res.result;
					this.getShareData()
					// 获取分享图
					this.getSharePoster()
                    // 初始化播放器
					this.setPlayer();
					if(this.websock){
						this.websock.close(); // 关闭websocket连接
					}else{
						this.initWebSocket();
					}
                }
            });
        },
        getLivingDetail() {
            if (this.token == null || this.token == undefined || this.token == '') {
                this.getLivingNoUserDetail()
                return
            }
            this.$api.living.livingDetail({
                token: this.token,
                id: this.$route.query.id
            }).then(res => {
                console.log(res);
                if (res.code == 200) {
					this.livingDetail = res.result;
					this.getShareData()
					// 获取分享图
					this.getSharePoster()
                    // 初始化播放器
					this.setPlayer();
					
					if(this.websock){
						this.websock.close(); // 关闭websocket连接
					}else{
						this.initWebSocket();
					}
                    console.log(
                        '用户名：',
                        this.livingDetail.username,
                        this.livingDetail.username != undefined && this.livingDetail.username != null && this.livingDetail.username != ''
                    );
                    // if (this.livingDetail.username != undefined && this.livingDetail.username != null && this.livingDetail.username != '') {
                    //     this.initWebSocket();
                    // }
                }
            });
        },
        // 播放器
        setPlayer() {
            this.instance = new Aliplayer({
                    id: this.playerId,
                    source: this.livingDetail.info.live_geturl,
                    width: '100%',
                    height: this.playStyle.height,
                    autoplay: true,
                    isLive: true,
                    rePlay: false,
                    playsinline: true,
                    preload: true,
                    x5LandscapeAsFullScreen: false,
                    x5_type:'h5', // 启用同层播放(如果微信没有启用同层播放，在Android微信上播放视频时，会自动弹出全屏播放， 覆盖Dom元素)
                    x5_orientation: 'portraint',
                    showBarTime: 5000,
                    useH5Prism: true,
                    //"isLive": true,
                    "rePlay": false,
                    // "preload": true,
                    "controlBarVisibility": "hover",
                    "x5_fullscreen": false, // true
                    "x5_video_position": "center", // top
                    // "x5_orientation":"landscape",
                },
                function (player) {
                    console.log('The player is created');
                    $('.prism-volume').before("<i class='control_btn'></i>");
                    $("video").attr('x5-video-player-type', 'h5');
                    $('.control_btn').on('click', function () {
                        if (!$('.prism-player').hasClass('fullScreen')) {
                            $('.prism-player').addClass('fullScreen');
                            $('.living_tabs').addClass('fullScreen');
                            $(".page_live").addClass('fullScreen');
                        } else {
                            $('.prism-player').removeClass('fullScreen');
                            $('.living_tabs').removeClass('fullScreen');
                            $(".page_live").removeClass('fullScreen');
                        }
                    });
                    player.on("error", function (e) {
                        $(".prism-ErrorMessage").hide();
                        player.show_video = true;
                    })
                }
            );
            // this.playStyle.height="100vh";
        },
        initWebSocket() {
            //初始化weosocket
            const wsuri = this.$publicData.wsuri;
            this.websock = new WebSocket(wsuri);
            console.log('112312');
            this.websock.onmessage = this.websocketonmessage;
            this.websock.onopen = this.websocketonopen;
            // this.websock.onerror = this.websocketonerror;
            this.websock.onclose = this.websocketclose;
        },
        websocketonopen() {
            //连接建立之后执行send方法发送数据
			//    发送房间号相关信息，以识别connect id
			console.log('1111123123123123',this.livingDetail)
			var uname = ''
			if(this.token != '' && this.token != null){
				// 已登录用户
				uname =
                this.livingDetail.username == null || this.livingDetail.username == '' || this.livingDetail.username == undefined ?
                this.livingDetail.info.userdata.username.substr(0, 3) + '****' + this.livingDetail.info.userdata.username.substr(-4) :
				this.livingDetail.username;
			}else{
				// 未登录用户
				uname = '游客' + new Date().getTime().toString().substr(-6);
			}
			console.log('uname',uname)
            var msg = JSON.stringify({
                text: '我来了~',
                livetype:1,
                username: uname,
                roomid: this.livingDetail.info.roomid,
                type: 'connect'
			});
			console.log('msg',msg)
            // //向服务器发送数据
			this.websocketsend(msg);
			this.userComeIn()
			// 添加心跳检测，每30秒发一次数据，防止连接断开（这跟服务器的设置有关，如果服务器没有设置每隔多长时间不发消息断开，可以不进行心跳设置）
			var that = this
			that.timer = setInterval(() => {
			// console.log('1111123123123123',this.livingDetail)
				try {
					var msg = JSON.stringify({
						text: '我来了~',
						livetype:0,
						username: uname,
						roomid: that.livingDetail.info.roomid,
						type: 'connect'
					});
					console.log('msg',msg)
					// //向服务器发送数据
					that.websocketsend(msg);
					console.log('发送消息');
				}catch(err){
					console.log('断开了：' + err);
				}
			}, 50000)

        },
        userComeIn() {
            var uname = ''
			if(this.token != '' && this.token != null){
				// 已登录用户
				uname =
                this.livingDetail.username == null || this.livingDetail.username == '' || this.livingDetail.username == undefined ?
                this.livingDetail.info.userdata.username.substr(0, 3) + '****' + this.livingDetail.info.userdata.username.substr(-4) :
				this.livingDetail.username;
			}else{
				// 未登录用户
				uname = '游客' + new Date().getTime().toString().substr(-6);
			}
            var msg = JSON.stringify({
                text: '我来了~',
                livetype:1,
                username: uname,
                roomid: this.livingDetail.info.roomid,
                type: 'UserComeIn'
			});
			console.log('msg',msg)
            // //向服务器发送数据
			this.websocketsend(msg);
        },
        websocketonerror() {
			console.log('连接建立失败重连')
            //连接建立失败重连
            this.initWebSocket();
        },
        websocketonmessage(e) {
			console.log('222:',e);
            console.log('111:',e.data);
            let d = e.data.split(':');
            if (d[0] == 'connect') {
                this.livingDetail.count = d[1];
            } else {
                this.socketMsg.push(e.data);
                //数据接收
                // console.log('接收数据##############');
                var tH = 0;
                if ($('.living_tabs').hasClass('fullScreen')) {
                    tH = $('#msgList1').prop('scrollHeight') + 100;
                } else {
                    tH = $('#msgList2').prop('scrollHeight') + 100;
                }
                if (this.goBottom && !this.isTouch) {
                    $('.msgList')
                        .stop(true, true)
                        .animate({
                            scrollTop: tH
                        }, 400);
                }
            }
        },
        websocketsend(Data) {
            //数据发送
            this.websock.send(Data);
        },
        websocketclose(e) {
            //关闭
            console.log('断开连接', e);
            var msg = 'close';
            this.websock.send(msg);
        },
        // 发送信息
        sendMsg() {
            if (this.msg == '') {
                return;
            }
            if (this.token == null || this.token == undefined || this.token == '') {
                if (userAgent && userAgent.indexOf('shidaijiyi') != -1) {
                    var memberParams = {
                        data: {}
                    };
                    this.$bridge.callhandler('sdjy://member/memberInfo', memberParams, data => {
                        if (data.code == 200) {
                            this.token = data.result.token;
                            this.getLivingDetail()
                        }
                    });
                } else {
                    localStorage.setItem('redirect', this.$router.currentRoute.fullPath)
                    this.$router.push({
                        path: '/login'
                    })
                    return
                }
            } else {
                this.sendMessage()
            }
        },
        sendMessage() {
            let uname =
                this.livingDetail.username == null || this.livingDetail.username == '' || this.livingDetail.username == undefined ?
                this.livingDetail.info.userdata.username.substr(0, 3) + '****' + this.livingDetail.info.userdata.username.substr(-4) :
                this.livingDetail.username;
            var msg = JSON.stringify({
                text: this.msg,
                username: uname,
                roomid: this.livingDetail.info.roomid,
                type: 'message'
            });
            this.websocketsend(msg);
            this.msg = '';
        },
        // 输入框回车发送
        checkMsg(key) {
            // console.log(key.which);
            if (this.msg == '') {
                return;
            }
            if (key.which == 13 || key.keyCode == 13 || key.charCode == 13) {
                this.sendMsg()
                // let uname =
                //     this.livingDetail.username == null || this.livingDetail.username == '' || this.livingDetail.username == undefined
                //         ? this.livingDetail.info.userdata.username.substr(0, 3) + '****' + this.livingDetail.info.userdata.username.substr(-4)
                //         : this.livingDetail.username;
                // var msg = JSON.stringify({ text: this.msg, username: uname, roomid: this.livingDetail.info.roomid, type: 'message' });
                // this.websocketsend(msg);
                // this.msg = '';
            }
        },
        msgTouchStart(e) {
            // console.log('touchstart',e.changedTouches[0]);
            this.startTouch = e.changedTouches[0].pageY;
            this.isTouch = true;
        },
        msgTouchEnd() {
            // console.log('touchend');
            this.isTouch = false;
        },
        msgTouchMove(e) {
            let y = e.changedTouches[0].pageY;
            if ($('.living_tabs').hasClass('fullScreen')) {
                let msgT = $('#msgList1').scrollTop();
                let listScroll = msgT - (y - this.startTouch); // * (window.screen.width / 750);
                this.startTouch = y;
                // console.log('move',y,msgT,listScroll,this.startTouch);
                $('#msgList1').scrollTop(listScroll);
            } else {
                let msgT = $('#msgList2').scrollTop();
                let listScroll = msgT - (y - this.startTouch); // * (window.screen.width / 750);
                this.startTouch = y;
                // console.log('move',y,msgT,listScroll,this.startTouch);
                $('#msgList2').scrollTop(listScroll);
            }
        },
        msgScroll(e, y) {
            // console.log('滚动了', e.target.scrollTop, e.target.offsetHeight);
            let lH = 0;
            if ($('.living_tabs').hasClass('fullScreen')) {
                lH = $('#msgList1 .interaction_content').height();
            } else {
                lH = $('#msgList2 .interaction_content').height();
            }
            // console.log('msgList:', lH);
            if (e.target.scrollTop + e.target.offsetHeight <= lH - 40) {
                this.goBottom = false;
            } else {
                this.goBottom = true;
            }

            // if ($('.living_tabs').hasClass('fullScreen')) {
            //     if ($('#msgList1 .i_item').length > 3) {
            //         setTimeout(function() {
            //             var len = 0;
            //             $('#msgList1 .i_item').each(function(i) {
            //                 console.log(i, $(this).position().top, $(this).position().top > 0);
            //                 $(this).css({
            //                     opacity: 1
            //                 });
            //                 if ($(this).position().top >= 0) {
            //                     $(this).css({
            //                         opacity: 1 - (10 - len * 3) / 10
            //                     });
            //                     len++;
            //                 } else {
            //                     $(this).css({
            //                         opacity: 0
            //                     });
            //                 }
            //             });
            //         }, 0);
            //     }
            // }
        },
        // 失去焦点时也没高度回弹
        resetWindow() {
            // $(window).scrollTop(0);
            window.scrollTo(-1, 1);
        },
        // 关注/取关匠人
        attention() {
            if (this.token == null || this.token == undefined || this.token == '') {
                if (userAgent && userAgent.indexOf('shidaijiyi') != -1) {
                    var memberParams = {
                        data: {}
                    };
                    this.$bridge.callhandler('sdjy://member/memberInfo', memberParams, data => {
                        if (data.code == 200) {
                            this.token = data.result.token;
                            this.attentionTradesman()
                        }
                    });
                } else {
                    localStorage.setItem('redirect', this.$router.currentRoute.fullPath)
                    this.$router.push({
                        path: '/login'
                    })
                    return
                }
            } else {
                this.attentionTradesman()
            }
        },
        attentionTradesman() {
            this.$api.tradesman
                .attention({
                    token: this.token,
                    tradesman_id: this.livingDetail.info.tradesman.id, //	否	int	匠人id
                    type: this.livingDetail.attention_status == null ? 1 : 2 //	否	int	1关注2取消关注
                })
                .then(res => {
                    if (res.code == 200) {
                        if (this.livingDetail.attention_status == null) {
                            this.$toast('关注成功');
                            this.livingDetail.attention_status = {};
                        } else {
                            this.$toast('取消关注成功');
                            this.livingDetail.attention_status = null;
                        }
                    }
                });
        },
        // 获取分享参数 -- 用于配微信分享
        getShareData() {
            const url = location.href.split('#')[0];
            this.$api.index.commonShare({
                url: url
            }).then(res => {
                if (res.code == 200) {
                    var data = res.result
                    this.shareConfig = data
                    console.log('this.shareConfig', this.shareConfig)
                    console.log('this.$route', this.$route)
                    this.shareFun()
                }
            })
        },
        // 分享
        shareFun() {
			var that = this
			// console.log('11111111111111')
            wx.config({
                debug: that.shareConfig.debug,
                beta: that.shareConfig.beta,
                jsApiList: that.shareConfig.jsApiList,
                appId: that.shareConfig.appId,
                nonceStr: that.shareConfig.nonceStr, // 随机串
                timestamp: parseInt(that.shareConfig.timestamp), // 时间戳
                signature: that.shareConfig.signature, // 签名
			});
			// console.log('222222222222')
			// console.log('that.livingDetail+1111',that.livingDetail)
            // 分享
            wx.ready(function () {
                const url = location.href.split('#')[0];
				console.log('url',url)
				console.log('that.livingDetail',that.livingDetail)
                var shareData = {
					title: that.livingDetail.info.title ? that.livingDetail.info.title : that.$publicData.shareDefaultTitleA, // 分享标题
					desc: that.livingDetail.info.describe ? that.livingDetail.info.describe : '', // 分享描述
					link: url, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
					imgUrl: that.livingDetail.info.thumb ? that.imageUrl + that.livingDetail.info.thumb : that.$publicData.domain + that.$publicData.shareDefaultIcon, // 分享图标
					success: function () {
						// 用户确认分享后执行的回调函数
						// alert('成功')
						// console.log('success')
					},
					cancel: function (e) {
						// console.log('e',e)
						// 用户取消分享后执行的回调函数
					}
				}

                wx.updateAppMessageShareData(shareData);
                wx.updateTimelineShareData(shareData);
            });
		},
		// 获取分享图片 ** 后台返回的
		getSharePoster(){
			var that = this
			var params = {
				id: that.$route.query.id,
				type: 3 // 1商品 2匠人 3直播 4约看
			}
			that.$api.common.shareImg(params).then(res=>{
				if(res.code == 200){
					that.posterUrl = res.result
				}else{
					that.$toast(res.message)
				}
			})
		}
    }
};
</script>

<style lang="postcss" scoped>
@import 'https://g.alicdn.com/de/prismplayer/2.7.2/skins/default/aliplayer-min.css';
</style>
